import React, { useState, useEffect } from 'react';
import { db, auth } from './firebase';
import { ref, onValue } from "firebase/database";
import { useNavigate } from 'react-router-dom';

function MyPage() {
  const [myHistory, setMyHistory] = useState([]);
  const navigate = useNavigate();
  const user = auth.currentUser;

  useEffect(() => {
    if (!user) {
      navigate('/');
      return;
    }

    const historyRef = ref(db, 'applications');
    const unsubscribe = onValue(historyRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const list = Object.keys(data)
          .map(key => ({ id: key, ...data[key] }))
          .filter(item => item.uid === user.uid);
        setMyHistory(list.reverse());
      } else {
        setMyHistory([]);
      }
    });
    return () => unsubscribe();
  }, [user, navigate]);

  // batchId 기준으로 그룹핑 (없으면 자기 id를 키로 사용)
  const batches = myHistory.reduce((acc, item) => {
    const key = item.batchId || item.id;
    if (!acc[key]) acc[key] = [];
    acc[key].push(item);
    return acc;
  }, {});

  const getStatusColor = (status) =>
    status === '승인' ? '#2ecc71' : status === '반려' ? '#e74c3c' : '#f1c40f';

  const getStatusBg = (status) =>
    status === '승인' ? '#f0fff4' : status === '반려' ? '#fff5f5' : '#fffdf3';

  const getStatusBorder = (status) =>
    status === '승인' ? '#a8e6b8' : status === '반려' ? '#f5c6c6' : '#ffeaa7';

  // 배치 전체 상태 요약 (모두 같으면 그 상태, 아니면 '처리중')
  const getBatchStatus = (items) => {
    const statuses = [...new Set(items.map(i => i.status))];
    return statuses.length === 1 ? statuses[0] : '처리중';
  };

  return (
    <div className="container" style={{ padding: '30px' }}>
      <h2>👨‍🎓 나의 시약 신청 내역</h2>
      <button
        onClick={() => navigate('/student')}
        style={{ padding: '8px 16px', backgroundColor: '#3498db', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer', fontWeight: 'bold' }}
      >
        🔍 시약 검색하러 가기
      </button>

      <div style={{ marginTop: '20px' }}>
        {Object.keys(batches).length === 0 ? (
          <p style={{ color: '#999' }}>신청 내역이 없습니다.</p>
        ) : (
          Object.entries(batches).map(([batchKey, items]) => {
            const { usageTime, purpose, timestamp } = items[0];
            const batchStatus = getBatchStatus(items);
            const submittedAt = timestamp ? new Date(timestamp).toLocaleString('ko-KR') : '';

            return (
              <div
                key={batchKey}
                style={{
                  border: `1px solid ${getStatusBorder(batchStatus)}`,
                  backgroundColor: getStatusBg(batchStatus),
                  padding: '18px 20px',
                  borderRadius: '12px',
                  marginBottom: '14px',
                }}
              >
                {/* 배치 헤더 */}
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: '8px' }}>
                  <div>
                    <p style={{ margin: '0 0 3px 0', fontSize: '0.9em' }}>⏰ <strong>{usageTime}</strong></p>
                    <p style={{ margin: '0 0 3px 0', fontSize: '0.9em' }}>📝 {purpose}</p>
                    {submittedAt && (
                      <p style={{ margin: 0, fontSize: '0.78em', color: '#aaa' }}>🕐 신청 시각: {submittedAt}</p>
                    )}
                  </div>
                  <b style={{ color: getStatusColor(batchStatus), fontSize: '1em', whiteSpace: 'nowrap' }}>
                    {batchStatus}
                  </b>
                </div>

                {/* 시약 목록 */}
                <ul style={{ margin: '12px 0 0 0', paddingLeft: '20px', fontSize: '0.9em', lineHeight: '1.8' }}>
                  {items.map(item => (
                    <li key={item.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <span>
                        <strong>{item.reagentName}</strong>
                        {item.location && item.location !== '위치 미상' && (
                          <span style={{ color: '#999', marginLeft: '6px', fontSize: '0.85em' }}>📍 {item.location}</span>
                        )}
                      </span>
                      {/* 배치 내 개별 상태가 다를 경우 개별 표시 */}
                      {getBatchStatus(items) === '처리중' && (
                        <b style={{ color: getStatusColor(item.status), fontSize: '0.85em', marginLeft: '10px' }}>
                          {item.status}
                        </b>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}

export default MyPage;
